import { useLocation, useNavigate, NavigateOptions } from '@reach/router';
import { useCallback } from 'react';

export function useSmartTo() {
  const location = useLocation();

  return useCallback((to: string) => {
    const [basePath, slug] = location.pathname.substr(1).split('/');

    if (to.indexOf('~/') === 0) {
      return `/${[basePath, to.substr(2)].filter(s => !!s).join('/')}`;
    }

    if (to.indexOf('~') === 0) {
      return `/${[basePath, slug, to.substr(1)].filter(s => !!s).join('/')}`;
    }

    // this takes the current path and adds to it
    // ex: current path is /foo/bar navigate(./baz) will result in /foo/bar/baz
    if (to.indexOf('./') === 0) {
      return `${[location.pathname, to.substr(2)].join('/')}`;
    }

    // this takes the current path and replaces the last segment with the new one
    // ex: current path is /foo/bar navigate(.baz) will result in /foo/baz
    if (to.indexOf('.') === 0) {
      return `${location.pathname.replace(/\/[^/]*$/, `/${to.substr(1)}`)}`;
    }

    return to;
  }, [location]);
}

export function useSmartNavigate() {
  const format = useSmartTo();
  const navigate = useNavigate();

  return useCallback(<S extends Record<string, unknown>>(to: string, opts?: NavigateOptions<S>) => navigate(format(to), opts), [format, navigate]);
}
